import RangeRestrictionRequests from '../../server/rangeRestriction';
import { addLoading, removeLoading } from './loading';

export const setRangeRestriction = (rangeRestrictions) => ({
  type: 'SET_RANGE_RESTRICTION',
  rangeRestrictions,
});

export const getRangeRestrictionList = () => async (dispatch) => {
  dispatch(addLoading());
  try {
    const rangeRestriction = await RangeRestrictionRequests.getRangeRestrictions();
    dispatch(setRangeRestriction(rangeRestriction));
  } finally {
    dispatch(removeLoading());
  }
};

export const getRangeRestriction = (rangeId) => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await RangeRestrictionRequests.getRangeRestriction(rangeId);
  } finally {
    dispatch(removeLoading());
  }
};

export const createRangeRestriction = (RangeRestriction) => async (dispatch) => {
  dispatch(addLoading());
  try {
    const newRangeRestriction = await RangeRestrictionRequests.createRangeRestriction(RangeRestriction);
    return newRangeRestriction;
  } finally {
    dispatch(removeLoading());
  }
};

export const updateRangeRestriction = (rangeRestriction) => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await RangeRestrictionRequests.updateRangeRestriction(rangeRestriction);
  } finally {
    dispatch(removeLoading());
  }
};

export const deleteRangeRestriction = (rangeRestrictionId) => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await RangeRestrictionRequests.deleteRangeRestriction(rangeRestrictionId);
  } finally {
    dispatch(removeLoading());
  }
};
